import {OfferType} from "@pg-rp/common-types";

import {IOfferDetailApplication} from "../../../../offer/types/IOfferDetailApplication";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {IPropertyDetailApplication} from "../../../../property/types/IPropertyDetailApplication";
import {IAmplitudeViewItemOffer, IAmplitudeViewItemProperty} from "../../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {IVendorDetailApplication} from "../../../../vendor/types/IVendorDetailApplication";
import {IAmplitudeLeadFormProductData} from "../../../tracking/amplitude/get_amplitude_lead_form_products";
import {TinderMultiLeadProperty} from "../../../types/tinder_multi_lead/TinderMultiLeadProperty";

/**
 * Maps a tinder deck property into the central `PRODUCTS[]` builder input shape.
 *
 * `getAmplitudeLeadFormProducts` only reads a small subset of each `*DetailApplication` type
 * (vendor.name; offer.id/name/type/region/construction_date_range.upper;
 * property.id/number/area/rooms/floor/price), so we populate exactly those fields and cast the
 * partial objects, keeping the central `PRODUCTS[]` builder as the single source of truth.
 *
 * Region note: a fully loaded `IPropertyDetail` carries the structured region stats, so its
 * products get the full `item_category3/4/5` (voivodeship/city/district). An `IRecommendedProperty`
 * (what the survey lead events receive, since the deck holds queue items) lacks those, so its
 * products resolve to country (`item_category2`) + `item_region_id` only.
 */
export const getTinderMultiLeadLeadData = (property: TinderMultiLeadProperty): IAmplitudeLeadFormProductData => {
    const {offer} = property;

    return {
        vendor: {detail: {name: offer.vendor.name} as unknown as IVendorDetailApplication},
        offer: {
            detail: {
                id: offer.id,
                name: offer.name,
                type: offer.type,
                region: offer.region,
                construction_date_range: offer.construction_date_range
            } as unknown as IOfferDetailApplication
        },
        property: {
            detail: {
                id: property.id,
                number: property.number,
                area: property.area,
                rooms: property.rooms,
                floor: property.floor,
                price: property.price
            } as unknown as IPropertyDetailApplication
        }
    };
};

/** Builds the `view_item` offer payload. Requires a fully loaded property (currency available). */
export const getTinderMultiLeadViewItemOffer = (property: IPropertyDetail): IAmplitudeViewItemOffer => {
    const {offer} = property;

    return {
        id: offer.id,
        name: offer.name,
        type: offer.type as OfferType,
        currency: offer.currency,
        vendor: {name: offer.vendor.name},
        region: offer.region
    };
};

export const getTinderMultiLeadViewItemProperty = (property: IPropertyDetail): IAmplitudeViewItemProperty => ({
    id: property.id,
    number: property.number,
    area: property.area,
    rooms: property.rooms,
    floor: property.floor,
    price: property.price
});
import {OfferType} from "@pg-rp/common-types";

import {IOfferDetailApplication} from "../../../../offer/types/IOfferDetailApplication";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {IPropertyDetailApplication} from "../../../../property/types/IPropertyDetailApplication";
import {IAmplitudeViewItemOffer, IAmplitudeViewItemProperty} from "../../../../tracking/amplitude/get_amplitude_view_item_event_properties";
import {IVendorDetailApplication} from "../../../../vendor/types/IVendorDetailApplication";
import {IAmplitudeLeadFormProductData} from "../../../tracking/amplitude/get_amplitude_lead_form_products";
import {TinderMultiLeadProperty} from "../../../types/tinder_multi_lead/TinderMultiLeadProperty";

/**
 * Maps a tinder deck property into the central `PRODUCTS[]` builder input shape.
 *
 * `getAmplitudeLeadFormProducts` only reads a small subset of each `*DetailApplication` type
 * (vendor.name; offer.id/name/type/region/construction_date_range.upper;
 * property.id/number/area/rooms/floor/price), so we populate exactly those fields and cast the
 * partial objects, keeping the central `PRODUCTS[]` builder as the single source of truth.
 *
 * Region note: a fully loaded `IPropertyDetail` carries the structured region stats, so its
 * products get the full `item_category3/4/5` (voivodeship/city/district). An `IRecommendedProperty`
 * (what the survey lead events receive, since the deck holds queue items) lacks those, so its
 * products resolve to country (`item_category2`) + `item_region_id` only.
 */
export const getTinderMultiLeadLeadData = (property: TinderMultiLeadProperty): IAmplitudeLeadFormProductData => {
    const {offer} = property;

    return {
        vendor: {detail: {name: offer.vendor.name} as unknown as IVendorDetailApplication},
        offer: {
            detail: {
                id: offer.id,
                name: offer.name,
                type: offer.type,
                region: offer.region,
                construction_date_range: offer.construction_date_range
            } as unknown as IOfferDetailApplication
        },
        property: {
            detail: {
                id: property.id,
                number: property.number,
                area: property.area,
                rooms: property.rooms,
                floor: property.floor,
                price: property.price
            } as unknown as IPropertyDetailApplication
        }
    };
};

/** Builds the `view_item` offer payload. Requires a fully loaded property (currency available). */
export const getTinderMultiLeadViewItemOffer = (property: IPropertyDetail): IAmplitudeViewItemOffer => {
    const {offer} = property;

    return {
        id: offer.id,
        name: offer.name,
        type: offer.type as OfferType,
        currency: offer.currency,
        vendor: {name: offer.vendor.name},
        region: offer.region
    };
};

export const getTinderMultiLeadViewItemProperty = (property: IPropertyDetail): IAmplitudeViewItemProperty => ({
    id: property.id,
    number: property.number,
    area: property.area,
    rooms: property.rooms,
    floor: property.floor,
    price: property.price
});
